import apiConfig from "constants/apiConfig";
import { PANDetails } from "types/wallet";
import axiosClient from "utils/axiosClient";

export const validatePAN = async (hubId: string, pan: string) : Promise<{status: boolean, pan: PANDetails}> => {
    const response = await axiosClient.post(apiConfig.VALIDATE_PAN.url.replace('<hubId>', hubId), {pan});
    return response.data;
}

export const storePAN = async (hubId: string, validation_id: any) : Promise<any> => {
    const response = await axiosClient.post(apiConfig.STORE_PAN.url.replace('<hubId>', hubId), {validation_id});
    return response.data;
}